/* src/app/components/doc-viewer-new/doc-viewer-content/doc-viewer-page-content/doc-viewer-page-content.component.scss */
:host {
  height: 100%;
}
iframe {
  flex: auto;
  border: 0px;
}
.disable-mouse-events {
  pointer-events: none;
}
::ng-deep .cdk-virtual-scrollable {
  overflow-x: hidden !important;
  overflow-y: auto !important;
  min-width: 50px;
}
/*# sourceMappingURL=doc-viewer-page-content.component.css.map */
